export function Process() {
  const steps = [
    {
      number: '01',
      title: 'Consultation & Strategy',
      description: 'We begin with an in-depth consultation to understand your brand, target markets, and communication goals. Our team develops a tailored strategy that aligns with your global expansion objectives.',
      icon: 'ri-discuss-line'
    },
    {
      number: '02',
      title: 'Planning & Preparation',
      description: 'Detailed project planning including script development, location scouting, talent casting, and technical setup. We coordinate all logistics for seamless international production.',
      icon: 'ri-file-list-3-line'
    },
    {
      number: '03',
      title: 'Production & Execution',
      description: 'Professional filming and event coverage with state-of-the-art equipment and experienced crews. We ensure high-quality output while respecting local cultures and regulations.',
      icon: 'ri-clapperboard-line'
    },
    {
      number: '04',
      title: 'Post-Production & Localization',
      description: 'Expert editing, color grading, and sound design. We localize content for different markets with professional translation, voice-over, and cultural adaptation services.',
      icon: 'ri-edit-box-line'
    },
    {
      number: '05',
      title: 'Distribution & Support',
      description: 'Multi-platform distribution strategy and ongoing support. We help optimize content for different channels and provide analytics to measure campaign effectiveness.',
      icon: 'ri-rocket-line'
    }
  ];

  return (
    <section id="process" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-purple-100 rounded-full mb-4">
            <span className="text-purple-600 font-semibold text-sm">OUR PROCESS</span>
          </div>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            How We <strong>Deliver Excellence</strong>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our proven five-step process ensures every project is executed flawlessly, from initial consultation to final delivery and beyond.
          </p>
        </div>

        <div className="space-y-8">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="relative bg-gradient-to-r from-gray-50 to-white rounded-2xl p-8 border border-gray-100 hover:shadow-xl transition-all duration-300 group"
            >
              <div className="flex flex-col md:flex-row gap-6 items-start">
                <div className="flex-shrink-0">
                  <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className={`${step.icon} text-white text-3xl`}></i>
                  </div>
                </div>

                <div className="flex-1">
                  <div className="flex items-center gap-4 mb-3">
                    <span className="text-5xl font-bold text-gray-200 group-hover:text-blue-200 transition-colors">
                      {step.number}
                    </span>
                    <h4 className="text-2xl font-bold text-gray-900">
                      <strong>{step.title}</strong>
                    </h4>
                  </div>
                  <p className="text-gray-600 leading-relaxed text-lg">
                    {step.description}
                  </p>
                </div>
              </div>

              {index < steps.length - 1 && (
                <div className="hidden md:block absolute left-14 bottom-0 w-0.5 h-8 bg-gradient-to-b from-blue-300 to-transparent transform translate-y-full"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
